import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getCollectionInfo,
  CollectionInfo,
} from '@/services/data-sources/get-collection-info';

interface UseGetCollectionInfoOptions extends Omit<
  UseQueryOptions<CollectionInfo>,
  'queryKey' | 'queryFn'
> {
  collectionId?: string;
  orgId?: string;
}

export const useGetCollectionInfo = (options?: UseGetCollectionInfoOptions) => {
  const { collectionId, orgId, ...queryOptions } = options || {};

  return useQuery<CollectionInfo>({
    queryKey: ['collection-info', orgId, collectionId],
    queryFn: async () => {
      if (!collectionId) {
        throw new Error('collectionId is required');
      }
      const response = await getCollectionInfo(collectionId);
      if ('detail' in response && typeof response.detail === 'string') {
        throw new Error(response.detail);
      }
      return response as CollectionInfo;
    },
    staleTime: 30 * 1000,
    ...queryOptions,
    enabled: !!collectionId && !!orgId && (queryOptions.enabled ?? true),
  });
};
